import { createApi } from "@reduxjs/toolkit/query/react";
import { components, operations } from "../../types/api";
import { baseQueryWithReauth } from "../../utils/baseQuery";

type DimensionMetricsResponse =
  components["schemas"]["DimensionMetricsResponse"];

type ApiResponseDimensionMetricsResponse =
  components["schemas"]["ApiResponse_DimensionMetricsResponse_"];

/**
 * Desgloses por dimensión de una campaña agrupada: dispositivo y audiencia.
 *
 * Van juntos en una sola petición porque salen de la misma tabla y el
 * dashboard los pinta a la vez; separarlos serían dos viajes para leer lo
 * mismo.
 */
export const dimensionMetricsApi = createApi({
  reducerPath: "dimensionMetricsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["DimensionMetrics"],
  endpoints: (builder) => ({
    getMergedDimensionMetrics: builder.query<
      DimensionMetricsResponse,
      operations["GetMergedDimensionMetrics"]["parameters"]
    >({
      query: (params) =>
        `/dimension-metrics/merged/${params.path.internalCampaignMergeId}`,
      transformResponse: (response: ApiResponseDimensionMetricsResponse) =>
        response.data as DimensionMetricsResponse,
      providesTags: ["DimensionMetrics"],
    }),
  }),
});

export const { useGetMergedDimensionMetricsQuery } = dimensionMetricsApi;
